<template>
  <div>
    <div v-for="(item, key) in model" :key="key" class="row my-3">
      <div class="col-md col-12 d-flex align-items-center mt-4 pt-1 ">
        <label class="mb-0">{{ item.goal.name | uppercase }}:</label>
      </div>

      <div class="col">
        <label class="data-name">Número:</label>
        <div v-if="isReadOnly">
          {{ item.number | empty }}
        </div>
        <validation-provider
          v-else
          v-slot="{ errors, failedRules }"
          :rules="setRulesWhenHasValue(item.profession, 'required')"
        >
          <custom-input
            v-model="item.number"
            :custom-error-msg="getErrorMessage(failedRules)"
            :error="errors[0]"
          />
        </validation-provider>
      </div>

      <div class="col">
        <label class="data-name">Profesión u Oficio:</label>
        <div v-if="isReadOnly">
          {{ item.profession | empty }}
        </div>
        <validation-provider
          v-else
          v-slot="{ errors }"
          :rules="setRulesWhenHasValue(item.number, 'required')"
        >
          <div class="d-flex align-items-center">
            <custom-input
              v-model="item.profession"
              class="w-100"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
            />
            <span
              v-if="!isReadOnly && !item.id && aggregable && key !== 0"
              class="fas fa-times-circle text-danger cursor-pointer ml-2"
              @click="$emit('remove', key)"
            />
          </div>
        </validation-provider>
      </div>
    </div>
    <div
      v-if="!isReadOnly && aggregable"
      class="d-flex justify-content-end mt-3"
    >
      <action-button
        class="ml-2"
        i="fas fa-file-plus"
        variant="success"
        @click="$emit('add')"
      >
        Añadir
      </action-button>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';

export default {
  name: 'Goals',
  components: {
    ValidationProvider,
    CustomInput,
    ActionButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    aggregable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    getErrorMessage() {
      return (failedRules) => {
        if (!failedRules) return null;
        if (failedRules.required) return 'El campo es requerido.';
        return null;
      };
    },
    setRulesWhenHasValue() {
      return (value, rules) => (!this.aggregable || value ? rules : '');
    },
  },
};
</script>

<style scoped>
.mw-25 {
  min-width: 25px;
}
</style>
